angular.module('zc.zenclerkS')
  .component('zcsCouponHistory', {
    templateUrl: '/templates/zenclerk_s/sites/campaigns/coupon/history.html',
    bindings: {
      project: '='
    },
    controller: ZcsCouponHistoryController,
  });

ZcsCouponHistoryController.$inject = ['$q', '$state', '$translate', 'ZcsAccessStats', 'ZcsIncentive', 'ZcsOemService', 'currencies'];
function ZcsCouponHistoryController($q, $state, $translate, ZcsAccessStats, ZcsIncentive, ZcsOemService, currencies) {
  const vm = this;

  vm.ZcsOemService = ZcsOemService;
  vm.currency = currencies[vm.project.currency];

  /* variables */
  vm.timeLimitTexts = [
    $translate.instant('sites.campaigns.couponHistory.aboutToExpire'),
    $translate.instant('sites.campaigns.couponHistory.expired')
  ];
  vm.pastIncentive = [];

  /* actions */
  vm.isAlmostEnded = isAlmostEnded;
  vm.isEnded = isEnded;

  vm.$onInit = () => {

    ZcsIncentive.all(vm.project.id).then(incentives => {
      vm.pastIncentive = incentives;

      let promises = _.map(vm.pastIncentive, incentive => ZcsIncentive.versions(vm.project.id, incentive.id));

      const pastIncentivePromise = $q.all(promises).then(results => {
        vm.pastIncentive = vm.pastIncentive.concat(_.flatten(results));
        vm.pastIncentive = _.chain(vm.pastIncentive)
          // by default they should be in "newest last"-order, but just in case, let's sort.
          // uniq behaves so that it takes the first.
          .sortBy(d => -new Date(d.created_at))
          .uniqBy(incentive => {
            // consider only start at - changing end at could be possible, but changing start at should not be...
            const getStartAtDate = i =>
              moment(i.start_at).format('YYYY-MM-DD_HH:mm');
            const prefix = `${incentive.coupon_code}_${getStartAtDate(
              incentive
            )}_`;

            if(incentive.discount_type === 'price') {
              return `${prefix}${incentive.discount_price}_${incentive.discount_type}`;
            } else if(incentive.discount_type === 'percent') {
              return `${prefix}${incentive.discount_percent}_${incentive.discount_type}`;
            } else if(incentive.is_free_shipping) {
              return `${prefix}freeshipping`;
            }
            return `${incentive.coupon_code}`;
          })
          .value();
      });

      pastIncentivePromise
        .then(res => {
        // remove the current active incentives from plans
          vm.pastIncentive = _.difference(vm.pastIncentive, vm.currentIncentives);
          // sort so that newest comes first
          vm.pastIncentive = _.sortBy(vm.pastIncentive, d => -new Date(d.created_at));
        });
    });
  };

  function isAlmostEnded(time) {
    if(time > new Date() && time < moment().add(3, 'days').toDate()) {
      return true;
    }
    return false;
  }

  function isEnded(time) {
    if(time < new Date()) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/coupon/history.js